<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <h3>YouMove</h3>
    </div>
    <p class="title">物联云平台</p>
    <p class="address_tel_fax">
      <span>地址：深圳市龙华区福城街道新和社区观澜大道61号</span>
    </p>
    <p class="email_wx">
      <a href="http://beian.miit.gov.cn">粤ICP备17038335号-11</a>
    </p>
    <p class="copy">Copyright &copy; 2018 - 2022 深圳矽友电子科技有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.email_wx a {
  color: #d3d3d3;
  text-decoration: none;
}
.email_wx a:hover {
  color: #fff;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue